import styled from 'styled-components'

export const FooterDiv = styled.div`
background: #02021C;
/* min-height:100px; */
display:flex;
justify-content:center;

.mobile_height{
    /* min-height:200px;   */
}
.row{
    /* display:flex; */
    /* justify-content:center; */
    align-items:center;
    min-height: 400px;
   
}
.bg{
        display:flex;
        flex-direction:column;
        text-align:start;
        /* padding-top:15px; */
        h2{
            font-family: Gilroy;
            font-style: normal;
            font-weight: 900;
            font-size: 25px;
            color: #FFFFFF;
            flex: none;
            margin: 25px 0px;
        } 
        p{
            font-family: Gilroy;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 25px;
            color: #FFFFFF;

        }
        img{
            width:130px;
            padding-top:15px;
        }
    
    }
    .bgg{
        display:flex;
        flex-direction:column;
        text-align:start;
        padding-bottom:10px;
       
        h2{
            font-family: Gilroy;
            font-style: normal;
            font-weight: 900;
            font-size: 25px;
            line-height: 32px;
            color: #FFFFFF;
            margin: 25px 0px;
        }
        p{
            font-family: Gilroy;
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            color:#FFFFFF;
            margin: 4px 0px;
        }
    
       
    }

    .bggg{
        display:flex;
        flex-direction:column;
        text-align:start;
        padding-bottom:40px;

        h2{
            font-family: Gilroy;
            font-style: normal;
            font-weight: 900;
            font-size: 25px;
            line-height: 32px;
            color: #FFF;
            flex: none;
        }
        button{
            background: #1DCDFE;
            border-radius: 6px;
            flex: none;
            margin: 8px 0px;
            border:none;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
      
     }
     input{
            border:none;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
        }
      
    }
    .bgggg{  
        text-align:start;
        padding-bottom:98px;

        h2{
            font-family: Gilroy;
            font-style: normal;
            font-weight: 900;
            font-size: 25px;
            line-height: 32px;
            color: #FFFFFF;
        }
        svg{
            margin:6px;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 21px;
            color:#FFF;
        }
      
    }
    
 
.copyright{
    p{
        display:flex;
        justify-content:center;
        font-family: Gilroy;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 18px;
        color: #FFFFFF;
    }
}
@media (max-width:720px){
    .roww{
        margin:10px;
    }
}
`